import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import AddCircleIcon from "@material-ui/icons/AddCircle";

import { toggleButtonTheme as add } from "../../config/theme";
import ControlButtons from "../ControlButtons/ControlButtons.jsx";
import AllItems from "./AllItems.jsx";
import { Box, Typography, Paper, CircularProgress } from "@material-ui/core";
import { useClasses } from "../../config/theme";

const SLICED_ITEMS_NUN = 3;

const RoomFeaturesView = (props) => {
    const { mainId } = useParams();
    const classes = useClasses();
    const itemsToShow = [];
    let roomFeaturesNum = 0;

    const controlButtons = props.addRoute
        ? [
              {
                  type: add,
                  icon: <AddCircleIcon />,
                  caption: "Создать",
                  link: () => props.addRoute(mainId),
              },
          ]
        : [];

    useEffect(() => {
        let params = mainId;
        props.initAction(params);
    }, [mainId]);

    if (props.items.length <= 0) {
        if (props.loading) {
            return (
                <Box mt={3}>
                    <CircularProgress size={35} />
                </Box>
            );
        }

        return (
            <Typography mb={3} variant={"h5"}>
                Нет категорий удобств
            </Typography>
        );
    }

    if (props.items.length > 0) {
        props.items.forEach((item) => {
            if (item.room_features?.length > 0) {
                roomFeaturesNum += item.room_features.length;
            }
        });
    }

    if (props.items.length > 0 && roomFeaturesNum <= 0) {
        return (
            <Paper elevation={3}>
                <Box p={3}>
                    <Typography mb={3} variant={"h5"}>
                        Нет удобств
                        {<ControlButtons items={controlButtons} />}
                    </Typography>
                </Box>
            </Paper>
        );
    }

    if (props.items.length > 0 && roomFeaturesNum > 0) {
        props.items.forEach((item, itemIdx) => {
            if (item.room_features?.length > 0) {
                const featuresToShow = item.allFeaturesShown
                    ? item.room_features
                    : item.room_features.slice(0, SLICED_ITEMS_NUN);

                itemsToShow.push(
                    <Box key={item.id} mb={1}>
                        <AllItems
                            title={item.name}
                            columns={props.columns}
                            items={featuresToShow}
                            loading={props.loading}
                            viewAction={props.viewAction}
                            editAction={props.editAction}
                            removeAction={props.removeAction}
                            updateParticularItem={props.updateParticularItem}
                            defaultSortfield="order"
                            roomFeatureCategoryId={item.id}
                        />
                        {item.room_features?.length > SLICED_ITEMS_NUN && (
                            <Box
                                mt={1}
                                mb={2}
                                display="flex"
                                justifyContent="flex-end"
                            >
                                <Typography
                                    onClick={props.showAllItemsHandler.bind(
                                        null,
                                        itemIdx,
                                    )}
                                    className={classes.toggle}
                                >
                                    {item.allFeaturesShown
                                        ? "Скрыть"
                                        : "Показать все"}
                                </Typography>
                            </Box>
                        )}
                    </Box>,
                );
            }
        });
    }

    return (
        <React.Fragment>
            <Box mb={3}>
                <Paper elevation={3}>
                    <Box p={3}>
                        <Typography mb={3} variant={"h5"}>
                            Удобства
                            {<ControlButtons items={controlButtons} />}
                        </Typography>
                    </Box>
                </Paper>
            </Box>
            {!props.loading && itemsToShow}
        </React.Fragment>
    );
};

RoomFeaturesView.propTypes = {
    params: PropTypes.string,
    fields: PropTypes.object,
    columns: PropTypes.object,
    title: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    initAction: PropTypes.func,
    viewAction: PropTypes.func,
    editAction: PropTypes.func,
    toggleAction: PropTypes.func,
    removeAction: PropTypes.func,
    loadExcelAction: PropTypes.func,
    setHotel: PropTypes.func,
    addRoute: PropTypes.func,
    listButtons: PropTypes.array,
    controlButtons: PropTypes.object,
    updateParticularItem: PropTypes.func,
    defaultSortfield: PropTypes.string,
    getHotelsAction: PropTypes.func,
    hotelsData: PropTypes.array,
    showAllItemsHandler: PropTypes.func,
};

export default RoomFeaturesView;
